import { Grid } from "@material-ui/core";
import { Box } from "@mui/material";
import CapacitacionesTP from "./CapacitacionesTP";

const CapacitacionesTPContent = () => {
  return (
    <>
      <div className="containerAdelantos">
        <Box mt={3} ml={5} className="Title" mb={2}>
          Plan de capacitaci&oacute;n
        </Box>
        <div className="contenedor2">
          <Grid className="containerBodyCapacitaciones">
            <CapacitacionesTP />
          </Grid>
        </div>
      </div>
    </>
  );
};
export default CapacitacionesTPContent;